import { StyleRules } from '@material-ui/core';
import { LinearProgressClassKey } from '@material-ui/core';

import { core as theme } from '../styles/core';

export const MuiLinearProgress: Partial<StyleRules<LinearProgressClassKey>> = {
  root: {
    height: 10,
    borderRadius: 2,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[100],
  },
  colorSecondary: {
    backgroundColor: theme.palette.grey[100],
  },
  barColorPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  barColorSecondary: {
    backgroundColor: theme.palette.error.main,
  },
};
